export interface DurationOption {
    value: number;
    label: string;
}

export function buildDurationOptions(incrementMinutes: number): DurationOption[] {
    const options: DurationOption[] = [];
    for (let m = incrementMinutes; m <= 240; m += incrementMinutes) {
        const h = Math.floor(m / 60);
        const mm = String(m % 60).padStart(2, "0");
        options.push({ value: m, label: `${h}:${mm}` });
    }
    return options;
}

export function formatDuration(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const mm = String(minutes % 60).padStart(2, "0");
    return `${h}:${mm}`;
}
